<div class="RecordsMeta">
  <p>
    Showing {{ currentRecords }} of <span class="font-weight-semi-bold">{{ totalRecords }}</span> entries
  </p>
</div>
